import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../../redux/hooks';
import useQuestionnaires from '../../../hooks/queries/useQuestionnaires';

import MedicalHistoryComponent from './component';

import { IQuestion } from '../types';

import { MEDICAL_QUESTIONNAIRES } from '../../../constants/questionnaires';
import { HISTORY_TYPE } from '../../../constants';

const MedicalHistory = () => {
  const navigate = useNavigate();
  const [formattedQuestions, setFormattedQuestions] = useState<IQuestion[]>([]);

  const [isQuestionnaireComplete, setIsQuestionnaireComplete] =
    useState<boolean>(true);

  const { id: patientId } =
    useAppSelector((state) => state.auth.currentUser) || {};

  const { questionnaires } = useQuestionnaires({
    type: HISTORY_TYPE.MEDICAL,
    patientId,
  });

  const toggleQuestionnaireCompletion = () =>
    setIsQuestionnaireComplete((prevState) => !prevState);

  const navigateToTasks = () => navigate('/tasks');

  useEffect(() => {
    if (!questionnaires) return;

    const updatedQuestions = questionnaires.map((question: IQuestion) => {
      const formattedQuestion = MEDICAL_QUESTIONNAIRES[question.question];
      return {
        ...question,
        question: formattedQuestion || question.question,
      };
    });

    setFormattedQuestions(updatedQuestions);
  }, [questionnaires]);

  return (
    <MedicalHistoryComponent
      isQuestionnaireComplete={isQuestionnaireComplete}
      questionnaires={formattedQuestions}
      toggleQuestionnaireCompletion={toggleQuestionnaireCompletion}
      navigateToTasks={navigateToTasks}
    />
  );
};

export default MedicalHistory;
